import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import CustomerLogin from './CustomerLogin.jsx';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MyOrder from './MyOrder';
import ClientAccount from './ClientAccount';
import OrderHistory from './OrderHistory';
import './CustomerPortal.css';
import { CustomerProvider } from './CustomerContext';
import ClientPortal from './ClientPortal';
import CharityPortal from './CharityPortal';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LoadingIndicator from '../LoadingIndicator'
import CircularProgress from '@mui/material/CircularProgress';
import { LoadScript } from '@react-google-maps/api';

export default function CustomerPortal(props) {
    const documentLoaded = useRef(false);
   
    const [isValidating, setisValidating] = useState(false);
    const [validatedEmail, setValidatedEmail] = useState('');
    const [selectedTab, setSelectedTab] = useState('1');
    const [mapsLoaded, setMapsLoaded] = useState(false);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

  
    const customerInfo = useRef(null);
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {

        if (documentLoaded.current == false) {

            document.getElementsByTagName('body')[0].addEventListener('ReloginRequired', (event) => loginChanged());
            documentLoaded.current = true;

            let queryParams = new URLSearchParams(window.location.search);
            let authCode = queryParams.get("auth");
            let type = queryParams.get("type");

            if (authCode != null && type != null) {
                if (type == 'verify' && authCode.length > 15) {
                    console.log('authCode=' + authCode);
                    setisValidating(true);
                    validateNewSignup(authCode);
                }
            }

            let token = getWebToken();
            if (token != null && customerInfo.current == null) {
                getLoggedInUser();
            }
            
        }

    }, []);

    function getLoggedInUser() {
        // get the logged in customer
        setisValidating(true);
        TokenService.customerPost('', 'GetCustomer')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    if (jsonData.Donation_Configurations !== undefined) {
                        jsonData.Donation_Configurations = JSON.parse(jsonData.Donation_Configurations);
                    }
                    if (jsonData.Client !== undefined) {
                        jsonData.Client = JSON.parse(jsonData.Client);
                    }
                    customerInfo.current = jsonData;

                    setisValidating(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }
   
    function getWebToken() {

        try {
            let webToken = JSON.parse(localStorage.getItem('Customer')).WebToken;
            if (webToken === '') {
                return null;
            }
            else {
                return webToken;
            }
        }
        catch (e) {
            console.log('CustomerPortal: error getting localStorage(Customer) ' + e);
        }

        return null;
    }


    function loginChanged() {
        // console.log("loginChanged");
        props.LoginChanged();
        getLoggedInUser();
    }

    function showLogin() {
        // console.log('showLogin');
        return (
            <div>
               
                <CustomerLogin validatedEmail={validatedEmail} LoginChanged={() => loginChanged()} />
            </div>);
    }

    function showValidating() {
        return <div className="App">
            <Card sx={{ minWidth: 300, maxWidth: 400, alignSelf: 'center', margin: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
                <CardContent>
                    <div>
                        <CircularProgress color="secondary" />
                    </div>
                </CardContent>
            </Card>

        </div>
    }


    function showApp() {
        if (customerInfo.current == null) {
            return null;
        }
        if (customerInfo.current.Donation_Configurations !== undefined && customerInfo.current.Client !== undefined) {
            // figure out if its a Fundraiser or Charity
            let orgLabel = '';
            for (let i = 0; i < customerInfo.current.Donation_Configurations.length; i++)
            {
                if (customerInfo.current.Donation_Configurations[i].Status == 'Active') {
                    orgLabel = customerInfo.current.Donation_Configurations[i].CompanyType;
                    break;
                }
            }

            if (orgLabel == '') {
                // just use the first one in the list
                 orgLabel = customerInfo.current.Donation_Configurations[0].CompanyType;
            }
            
            return (
                <CustomerProvider value={{ customer: customerInfo.current }}>
                    <TabContext value={selectedTab} >
                        <TabList
                            className="tabHeaderCustomerPortal"
                            variant="fullWidth"
                            textColor="secondary"
                            indicatorColor="primary"
                            onChange={handleTabChange} aria-label="Charity Tabs">
                            <Tab style={{ fontWeight: 'bold' }}
                                label="Customer"
                                value="1" />

                            <Tab style={{ fontWeight: 'bold' }}
                                label={<span>{orgLabel} <img src='/images/DonateIcon.png' style={{ height: '24px', width: '24px' }} /></span>}
                                value="2" />
                        </TabList>

                        <TabPanel value="1" style={{ padding: '10px' }}>
                            <ClientPortal />
                        </TabPanel>
                        <TabPanel value="2" style={{ padding: '5px' }}>
                            <CharityPortal />
                        </TabPanel>
                    </TabContext>
                </CustomerProvider>)
            
        }
        else if (customerInfo.current.Donation_Configurations !== undefined) {
            return (
                <CustomerProvider value={{ customer: customerInfo.current }}>
                    <CharityPortal />
                </CustomerProvider>)
        }
        else {
            return (
                <CustomerProvider value={{ customer: customerInfo.current }}>
                    <ClientPortal />
                </CustomerProvider>)
        }

      
    }

    return (
        <LoadScript
           
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={['places']} // Make sure to include 'places' library
            onLoad={() => setMapsLoaded(true)}
        >
            {
                isValidating ?
                    showValidating()
                    :
                    getWebToken() === null ?
                        showLogin() : showApp()
            }
        </LoadScript>
    )
}
